import client from 'core/axios';


// https://www.notion.so/schoolinkshome/Member-dashboard-endpoints-c335c65ae90e4523aa2166f045b57cd0#e9368ca1fac14b0f9a506fc36b89f662
const Api = {
  // Get Alum contact info API
  getAlumniContactInfo: alumniId =>
    client.get(`v1/alumni/contact-info/${alumniId}`),

  // Update Alum contact info API
  updateAlumniContactInfo: (alumniId, payload) =>
    client.patch(`v1/alumni/contact-info/${alumniId}`, payload),

  // Confirm alum contact info API
  confirmAlumniContactInfo: (alumniId, payload) =>
    client.post(`v1/alumni/contact-info/${alumniId}/confirm`, payload),

  // Remove Alum contact info API
  // entityType: email_address or phone_number
  removeAlumniContactInfo: (alumniId, entityType) =>
    client.post(
      `v1/alumni/contact-info/${alumniId}/delete/${entityType}`,
    ),
};

export default Api;
